import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { MenuItem, SelectField } from 'material-ui'
import * as SettingsActions from '../../../state/actions/message-settings'
import SocialLink from './SocialLink'
import HelpButton from '../HelpButton'
import styles from './link-styles'
import SocialLinksHelperDialog from './SocialLinksHelpDialog'

const linkTypes = ['facebook', 'google', 'yelp']

class SocialLinks extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedLocation: null,
      helpOpen: false,
    }
  }

  componentWillReceiveProps({
    activeLocation: nextActiveLocation,
    links: nextLinks,
  }) {
    const { selectedLocation } = this.state
    const {
      activeLocation,
      hasDSO,
    } = this.props
    switch (true) {
      case hasDSO && !!nextActiveLocation: {
        const updatedSelectedLocation = this.findLinks(nextActiveLocation.id, nextLinks)
        this.setState({ selectedLocation: updatedSelectedLocation })
        break
      }
      case hasDSO: {
        const { id: activeLocId } = activeLocation
        const dsoSelectedLoc = this.findLinks(activeLocId, nextLinks)
        this.setState({ selectedLocation: dsoSelectedLoc })
        break
      }
      case !nextLinks:
        break
      case !selectedLocation:
        this.setState({ selectedLocation: nextLinks[0] })
        break
      default: {
        const defaultSelecedLoc = this.findLinks(selectedLocation.location_id, nextLinks)
        this.setState({ selectedLocation: defaultSelecedLoc })
        break
      }
    }
  }

  findLinks = (selectedLocationId, links) =>
    links.find(location => location.location_id === selectedLocationId)

  toggleDialog = helpOpen => this.setState({ helpOpen })

  updateLink = (type, link) => {
    const {
      selectedLocation: { location_id: locationId },
    } = this.state
    const { updateSocialLink } = this.props
    updateSocialLink(type, link, locationId)
  }

  updateSelectedLocation = (event, value) => {
    const { links } = this.props
    const newLocation = links[value]
    this.setState({ selectedLocation: newLocation })
  }

  render() {
    const { selectedLocation, helpOpen } = this.state
    const { hasDSO, links } = this.props
    if (!selectedLocation) return <div />
    const selectedLinks = selectedLocation.links

    return (
      <div style={styles.wrapper}>
        <div style={styles.header}>
          <div style={styles.headerText}>Social Links</div>
          {!hasDSO && (
            <SelectField
              value={selectedLocation}
              onChange={this.updateSelectedLocation}
              floatingLabelText="Location"
              style={styles.selectField}
            >
              {links.map(link => (
                <MenuItem
                  value={link}
                  key={link.location_id}
                  primaryText={link.location_name}
                />
              ))}
            </SelectField>
          )}
          <div style={styles.helpButtonContainer}>
            <HelpButton onTouchTap={() => this.toggleDialog(true)} />
          </div>
        </div>
        {linkTypes.map(linkType => (
          <SocialLink
            key={linkType}
            link={selectedLinks[`${linkType}_url`]}
            type={linkType}
            updateLink={this.updateLink}
          />
        ))}
        {helpOpen && (
          <SocialLinksHelperDialog toggleDialog={this.toggleDialog} />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({
  account: {
    auth: { hasDSO },
    user: { activeLocation },
  },
  messageSettings: { socialLinks: links },
}) => ({
  activeLocation,
  hasDSO,
  links,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...SettingsActions }, dispatch)

SocialLinks.propTypes = {
  activeLocation: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    additional_recipients: PropTypes.arrayOf(PropTypes.object),
    city: PropTypes.string,
    country_code: PropTypes.string,
    created_at: PropTypes.string,
    doctor_id: PropTypes.string,
    earliest_same_day_reminder_hour: PropTypes.number,
    facebook_url: PropTypes.string,
    forwarding_email: PropTypes.string,
    google_url: PropTypes.string,
    id: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    name: PropTypes.string,
    office_email: PropTypes.string,
    office_phone: PropTypes.string,
    phone_numbers: PropTypes.arrayOf(PropTypes.object),
    practice_id: PropTypes.number,
    state: PropTypes.string,
    street_address: PropTypes.string,
    timezone: PropTypes.string,
    updated_at: PropTypes.string,
    website: PropTypes.string,
    yelp_url: PropTypes.string,
    zip: PropTypes.string,
  }),
  hasDSO: PropTypes.bool.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      location_id: PropTypes.string.isRequired,
      location_name: PropTypes.string.isRequired,
      links: PropTypes.shape({
        facebook_url: PropTypes.string,
        google_url: PropTypes.string,
        yelp_url: PropTypes.string,
      }).isRequired,
    }),
  ),
  updateSocialLink: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(SocialLinks)



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/SocialLinks.js